/**
 * @param {Number} multipleOf - The number that the generated numbers should be a multiple of
 * @param {Number} amountOfMultiples - The amount of numbers you want to generate
 * @returns {Number[]}
 */
export const multiplesOf = (multipleOf, amountOfMultiples) => {
    const multipleOfNumbers = [];
    let x = 1;

    for (let i = 1; i <= amountOfMultiples; i++) {
        multipleOfNumbers.push(multipleOf * x);
        x++;
    }

    return multipleOfNumbers;
};
